const getLegacyPortalUrlForApp = (appId: string) =>
  `${process.env.REACT_APP_XDP_DEVPORTAL_URL}/app/${appId}/info`;

export default getLegacyPortalUrlForApp;
